import React, { useMemo, useRef, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Button, Card, Container } from "react-bootstrap";
import CommonTable from "../../components/tables/CommonTable";
import NewObject from "../../components/detail/NewObject";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart, faPlus } from "@fortawesome/free-solid-svg-icons";
import useAuth from "../../hooks/useAuth";
import { Users } from "react-feather";
import { NavLink } from "react-router-dom";
import useCustomFieldsHelper from "../../hooks/useCustomFieldsHelper";

const People = () => {
  const [resultCount, setResultCount] = useState(0);
  const [showModal, setShow] = useState(false);
  const childRef = useRef();
  const { user } = useAuth();
  const { getColumnsForElementType } = useCustomFieldsHelper();
  const columns = useMemo(() => {
    return getColumnsForElementType("people");
  }, []);

  return (
    <React.Fragment>
      <Helmet defer={false} title="People" />
      <Container fluid className="p-0">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="d-flex align-items-center">
            <h1 className="h3 mb-0">
              <Users className="me-2" />
              People {typeof resultCount === "string" && `(${resultCount})`}
            </h1>
            {user?.role !== "Root" && (
              <NavLink to={{ pathname: "/favourite", search: "?type=people" }}>
                <FontAwesomeIcon
                  className="ms-4 me-2 text-primary cursor-pointer"
                  icon={faHeart}
                />
                <span>Favourites</span>
              </NavLink>
            )}
          </div>
          {(user?.role === "Admin" ||
            (user?.role === "User" && user?.createPeople)) && (
            <Button className="text-nowrap" onClick={() => setShow(true)}>
              <FontAwesomeIcon icon={faPlus} fixedWidth className="me-1" />
              Create New
            </Button>
          )}
        </div>
        <Card className="bg-white p-3">
          <CommonTable
            ref={childRef}
            setCountParent={setResultCount}
            apiName="people"
            columns={columns}
            showExport={true}
            hidePersonRef
          />
        </Card>
      </Container>
      <NewObject
        showModal={showModal}
        closeModal={() => setShow(false)}
        apiName="people"
      />
    </React.Fragment>
  );
};

export default People;
